import InformationAPI from "@/service/infomation.api.js";
import AuthAPI from "@/service/auth.api.js";

const state = {
  mobile_otp: "",
  ref_otp: "",
  token: "",
  userData: null,
};

const mutations = {
  updateMobile(state, payload) {
    state.mobile = payload;
  },
  updateRefOTP(state, payload) {
    state.ref_otp = payload;
  },
  updateToken(state, payload) {
    state.token = payload;
  },
  SET_USER_DATA(state, payload) {
    state.userData = payload;
  },
};

const getters = {
  getMobile(state) {
    return state.mobile;
  },
  getRefOtp(state) {
    return state.ref_otp;
  },
  getToken(state) {
    return state.token;
  },
  getUserData(state) {
    return state.userData;
  },
};

const actions = {
  async funcPostRefnoInform({ dispatch, commit }, req) {
    return await InformationAPI.PostRefnoInform(req)
      .then((res) => {
        commit("updateMobile", req.mobile_otp);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  async funcPostRequestOTP({ dispatch, commit }, req) {
    return await AuthAPI.PostRequestOTP(req)
      .then((res) => {
        commit("updateRefOTP", res.Refotp);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  async funcPostUpdateAuthConfirm({ commit }, req) {
    return await InformationAPI.PostUpdateAuthConfirm(req)
      .then((res) => res.data)
      .catch((error) => { throw error; });
  },

  async funcPaotangExchange({ commit }, { code, state }) {
    return await InformationAPI.PostPaotangExchange(code, state)
      .then((res) => {
        console.log('[PaotangOAuth] exchange response:', res.data);
        return res.data;
      })
      .catch((error) => {
        console.error('[PaotangOAuth] exchange error:', error);
        throw error;
      });
  },

  async funcPaotangAuthInit({ commit }, cifno) {
    return await InformationAPI.PostPaotangAuthInit(cifno)
      .then((res) => {
        console.log('[PaotangOAuth] init response:', res.data);
        return res.data;
      })
      .catch((error) => {
        console.error('[PaotangOAuth] init error:', error);
        throw error;
      });
  },

  async funcPostCheckOTPMatch({ dispatch, commit }, req) {
    //dispatch('loadingDialog/loading', true, { root: true });
    return await AuthAPI.PostCheckOTPMatch(req)
      .then((res) => {
        //dispatch('loadingDialog/loading', false, { root: true });
        commit("updateToken", res.data.access_token);
        return res.data;
      })
      .catch((error) => {
        //dispatch('errorMessage/openModalErrorMessage', error, { root: true });
        //dispatch('loadingDialog/loading', false, { root: true });
        throw error;
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}; 